export function DataTable(state = null, action) {
  switch (action.type) {
    case 'SET_DATA_TABLE': {
      return action.payload
    }
    default:
      return state
  }
}
